import React from 'react';
import Hero from '../components/Hero';
import MenuHighlights from '../components/MenuHighlights';

const Home = () => {
    return (
        <div>
            <Hero />
            <div className="container" style={{ padding: '50px 20px', textAlign: 'center' }}>
                <MenuHighlights />
            </div>
        </div>
    );
};

export default Home;
